// Basic profanity/spam filter for user-generated content
// Catches obvious abuse — not exhaustive, but blocks low-effort spam

const BLOCKED_PATTERNS = [
  // Common spam patterns
  /https?:\/\//i, // URLs
  /\b(buy|sell|discount|click here|free money|crypto|nft)\b/i,
  // Repeated characters (spam indicator)
  /(.)\1{6,}/, // 7+ of the same character
  // All caps abuse (20+ uppercase letters in a run, spaces allowed between)
  /(?:[A-Z]\s*){20,}/,
];

const BLOCKED_WORDS = [
  "fuck",
  "shit",
  "ass",
  "bitch",
  "dick",
  "pussy",
  "cunt",
  "nigger",
  "faggot",
  "retard",
];

export function validateComment(text: string): string | null {
  if (!text || text.trim().length === 0) return null;

  const trimmed = text.trim();

  if (trimmed.length > 280) {
    return "Comment must be under 280 characters.";
  }

  for (const pattern of BLOCKED_PATTERNS) {
    if (pattern.test(trimmed)) {
      return "Comment contains blocked content.";
    }
  }

  const lower = trimmed.toLowerCase();
  for (const word of BLOCKED_WORDS) {
    // Match whole words only
    const regex = new RegExp(`\\b${word}\\b`, "i");
    if (regex.test(lower)) {
      return "Comment contains inappropriate language.";
    }
  }

  return null;
}
